import { render, staticRenderFns } from "./promptTemplate.vue?vue&type=template&id=0bd4bfa0&scoped=true&"
import script from "./promptTemplate.vue?vue&type=script&lang=js&"
export * from "./promptTemplate.vue?vue&type=script&lang=js&"
import style0 from "./promptTemplate.vue?vue&type=style&index=0&id=0bd4bfa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4bfa0",
  null
  
)

export default component.exports